import { Injectable } from '@angular/core';
import { DocumentTemplatesService, gungComparatorHelper } from 'gung-common';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { ActivityInternalListConfigService, ActivityInternalService, ActivityInternalExportService, MetadataService, ActivityInternal, ActivityInternalStatusFilter, ActivityInternalTypeFilter } from 'gung-standard';
import { BehaviorSubject, Observable, ReplaySubject, Subject, delay, map, switchMap, tap } from 'rxjs';
import { CultActivityInternalTableComponent } from '../components/cult-activity-internal-table/cult-activity-internal-table.component';
import { format } from 'date-fns';

export class ActivityInternalCustomerResponsibleFilter extends SimpleConfigBaseFilter<ActivityInternal> {
  constructor(private metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'CUSTOMER_RESPONSIBLE';
  }

  getOptionIds(item: ActivityInternal): string[] {
    const value = this.metadataService.getMetadataValue('salj', 'saljarenamn', item.customerResponsible);
    if (!value) {
      return ['UNDEFINED'];
    }
    return [value];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class ActivityInternalDateFilter extends SimpleConfigBaseFilter<ActivityInternal> {
  type = 'dateRangeFilter';
  getName(): string {
    return 'ACTIVITY_DATE';
  }

  getOptionIds(item: ActivityInternal): string[] {
    return [format(new Date(item.activityDate), 'yyMMdd')];
  }

  getOptionName(key: string): string {
    return key;
  }
}


@Injectable({
  providedIn: 'root'
})
export class CultActivityInternalListConfigService extends ActivityInternalListConfigService {
  activityType: Subject<string> = new BehaviorSubject<string>('');

  getLayouts(): ListLayout<ActivityInternal>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CultActivityInternalTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getItems(): Observable<ActivityInternal[]> {
    const openedActivities = ['10', '20'];
    return this.activityType.pipe(
      switchMap((type) => {
        return this.activityInternalService.getAll().pipe(
          map(result => {
            const today = new Date();
            if (this.customerId) {
              return result.filter(r => r.customerId === this.customerId);
            }
            if(type === "expired"){
              
              return result.filter(act => new Date(act.activityEndDate && new Date(act.activityEndDate) >= new Date(act.activityDate) ? act.activityEndDate : act.activityDate) < today && openedActivities.includes(act.status));
            }
            if(type === "opened"){
              return result.filter(act => new Date(act.activityEndDate && new Date(act.activityEndDate) >= new Date(act.activityDate) ? act.activityEndDate : act.activityDate) >= today && openedActivities.includes(act.status));
            }
            if(type === "all"){
              return result;
            } else {
              return result;
            }          }),
          map(result =>
            result.sort((a, b) => gungComparatorHelper(new Date(a.activityDate), new Date(b.activityDate), 1))
          )
        );
      })
    )
  }

  getFilters(): ConfigBaseFilter<ActivityInternal>[] {
    return [
      new ActivityInternalStatusFilter(this.metadataService),
      new ActivityInternalTypeFilter(this.metadataService),
      new ActivityInternalCustomerResponsibleFilter(this.metadataService),
      new ActivityInternalDateFilter()
    ];
  }
}
